import { render, staticRenderFns } from "./background-picker.vue?vue&type=template&id=6ea2ec88&scoped=true&"
import script from "./background-picker.vue?vue&type=script&lang=js&"
export * from "./background-picker.vue?vue&type=script&lang=js&"
import style0 from "./background-picker.vue?vue&type=style&index=0&id=6ea2ec88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea2ec88",
  null
  
)

export default component.exports